import React, { useContext, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppContext } from './AppProvider';
import { apiHeader, apiRequest } from "./utils/Axios";

// Halaman
import PageHome from './pages/Home';
import PageLogin from './pages/Login';

const AppRoute = () => {
    const { deviceId, auth, setAuth, userData, setUserData } = useContext(AppContext);

    useEffect(() => {
        apiHeader({ deviceid:deviceId, authorization:`Bearer ${auth}` });
    }, [deviceId, auth]);

    setInterval(() => {
        // Melakukan request validasi token
        const fetchData = async () => {
            const result = await apiRequest('POST', '/auth/validate', {}, 5000);
            console.log(result);
            if (result.code === 'expired') {
                handleLogout();
            }else{
                if (!userData){
                    setUserData(userData);
                }
            }
        }
        auth && fetchData();
    }, 10000);

    const handleLogout = () => {
		setAuth(null);
		localStorage.removeItem('auth');

		setUserData(null);
		localStorage.removeItem('userData');
	};
    
    return(
        <BrowserRouter>
            <Routes>
                <Route path="/" element={auth ? <PageHome /> : <Navigate to="/login" replace /> } />
                <Route path="/login" element={auth ? <Navigate to="/" replace /> : <PageLogin />} />
            </Routes>	
        </BrowserRouter>
    )
};

export default AppRoute;